import {
  PATTERN_PREVIEW_CLASSES,
  PATTERN_PREVIEW_LOCALE_CLASSES,
  PATTERN_PREVIEW_ROW_CLASSES,
  PATTERN_PREVIEW_VALUE_CLASSES,
} from '../scalar.tokens';

import { type PatternPreviewProps } from './PatternPreview.types';

/**
 * What the chosen format actually produces, in every locale the brand serves.
 *
 * Both rows, always. One pattern is stored for every member, and `MMMM` renders
 * "March" and "مارس" — an operator choosing between formats is choosing for both
 * audiences at once and should be able to see both.
 *
 * Presentation only (U5).
 */
export function PatternPreview({ id, rows }: PatternPreviewProps) {
  return (
    <span id={id} className={PATTERN_PREVIEW_CLASSES}>
      {rows.map((row) => (
        <span key={row.locale} className={PATTERN_PREVIEW_ROW_CLASSES}>
          <span className={PATTERN_PREVIEW_LOCALE_CLASSES}>{row.label}</span>
          {/*
            The rendered date carries its OWN locale's direction: an Arabic
            sample sitting in an English preview row (or the reverse) would be
            reordered by the bidi algorithm into a date nobody will ever see.
          */}
          <span
            data-pattern-preview={row.locale}
            dir={row.locale === 'ar' ? 'rtl' : 'ltr'}
            className={PATTERN_PREVIEW_VALUE_CLASSES}
          >
            {row.text}
          </span>
        </span>
      ))}
    </span>
  );
}
